
import { useEffect } from 'react'
import { connect } from 'react-redux'

import { useAppDispatch } from '../../store'
import { reset as patientBannerReset } from '../PatientFolder/PatientBanner/actions'

import { Alerts } from './alerts'
import { MyMessages } from './my-messages'
import { PatientList } from './patient-list'
import { Todos } from './todos'

import './styles.scss'

function Dashboard (): JSX.Element {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(patientBannerReset())
  }, [ dispatch ])

  return (
    <div className='pl-4 pr-[0.2rem]'>
      <div className='flex flex-col flex-wrap gap-4'>
        <div className='flex flex-row gap-4 w-full'>
          <div className='flex-1 h-80 overflow-y-scroll rounded-[1rem]'>
            <Alerts />
          </div>

          <div className='flex-1 h-80 overflow-y-scroll rounded-[1rem]'>
            <MyMessages />
          </div>
        </div>

        <div className='flex-1 max-h-[400px] overflow-y-scroll rounded-[1rem]'>
          <Todos scope='mine' />
        </div>

        <div className='flex-1 rounded-[1rem]'>
          <PatientList title='Open Encounters' />
        </div>
      </div>
    </div>
  )
}

export default connect()(Dashboard)
